/** @jsxImportSource @emotion/react */
import * as s from "./style"
import { IoClose } from "react-icons/io5";

const Popup = ({ popupData, selectedCategories, onClickCloseButton, mode, index }) => {
    return (
        <div id={`popup_${index}`} css={s.mainContainer}>
            <div css={s.top}/>
            <p css={s.closer} onClick={onClickCloseButton}><IoClose /></p>
            { selectedCategories && popupData &&
                <div css={s.content}>
                    <header css={s.header}>
                        <p css={s.name}>{popupData.adminNm}</p>
                    </header>
                    <div css={s.textContainer}>
                        <p css={s.name}>{popupData.data[index].category}</p>
                        <p css={s.text}>{popupData.data[index].val === "" ? "데이터 없음" : `${popupData.data[index].val.toLocaleString()}${selectedCategories[index].unit === "-" ? "" : selectedCategories[index].unit}`}</p>
                    </div>
                    { mode !== 'singleMap' && mode !== 'doubleMap' &&
                        <div css={s.textContainer}>
                            <p css={s.name}>{popupData.data[1].category}</p>
                            <p css={s.text}>{popupData.data[1].val === "" ? "데이터 없음" : `${popupData.data[1].val.toLocaleString()}${selectedCategories[1].unit === "-" ? "" : selectedCategories[1].unit}`}</p>
                        </div>
                    }
                </div>
            }
        </div>
    );
};

export default Popup;